/* eslint-disable complexity */
/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import basketUtils from 'utils/Basket';
import { fontSizes } from 'style/config';
import {
    Text, Button, Flex, Icon, Link
} from 'components/ui';
import OutOfStockButton from 'components/AddToBasketButton/OutOfStockButton/OutOfStockButton';
import skuUtils from 'utils/Sku';
import { isRewardBundlingEnabled } from 'utils/BeautyInsider';
import LanguageLocale from 'utils/LanguageLocale';
import Location from 'utils/Location';
import Debounce from 'utils/Debounce';
import ReactDOM from 'react-dom';
import rrcUtils from 'utils/RrcTermsAndConditions';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';
import {
    breakpoints, space, colors, mediaQueries
} from 'style/config';
import quicklookModalUtils from 'utils/Quicklook';
import basketConstants from 'constants/Basket';
import Empty from 'constants/empty';
import DeliveryFrequency from 'utils/DeliveryFrequency';
import deliveryOptionsUtils from 'utils/DeliveryOptions';
import storeUtils from 'utils/Store';
import helpersUtils from 'utils/Helpers';
import promoUtils from 'utils/Promos';
import productPageSOTBindings from 'analytics/bindingMethods/pages/productPage/productPageSOTBindings';
import processEvent from 'analytics/processEvent';
import rwdBasketUtils from 'utils/RwdBasket';
import skuHelpers from 'utils/skuHelpers';
import skuUtil from 'utils/Sku';
import { isChangeQuantityEnabled } from 'utils/arChangeQuantityFlag';
import chooseOptionsModalUtils from 'utils/ChooseOptionsModal/ChooseOptionsModalUtils';
import isFunction from 'utils/functions/isFunction';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import UI from 'utils/UI';
import { getCsfRoute } from 'components/CreatorStoreFront/helpers/getCsfRoute';
import {
    CSF_EVENT_TYPES,
    applyProductInteractionToActiveCommissioningU1,
    getActiveCommissioningU1State,
    getCsfDynamicCommissioningU5,
    isDynamicCommissioningEnabled,
    logCsfAtbEvent
} from 'utils/CreatorStoreFront/dynamicCommissioning';
import { CSF_DC_ATB_SOURCES, CSF_DC_U1_BESTSELLER_SENTINEL } from 'constants/CsfDynamicCommissioning';

const { isIOSSafari } = UI;
const { getLocalisedDataFromResource } = LanguageLocale;
const { formatFrequencyType } = DeliveryFrequency;
const { isNDDNewDeliveryName } = deliveryOptionsUtils;
const { formatSiteCatalystPrice, deferTaskExecution } = helpersUtils;
const { BasketType, PROMO_WARNING } = basketConstants;
const { ADD_TO_BASKET_TYPES: ADD_BUTTON_TYPE } = basketUtils;
const { findBasketTypeBySkuId } = rwdBasketUtils;

const THROTTLE_DELAY = 200;
const ADDED_TEXT_TIMEOUT = 1000;
const BASKET_TYPE_TO_TEXT = {
    [BasketType.BOPIS]: 'storePickup',
    [BasketType.SameDay]: 'sameDayDelivery',
    [BasketType.Standard]: 'standardShipping'
};

import AddToBasketButtonEN from 'components/AddToBasketButton/locales/AddToBasketButton_en_US';
import AddToBasketButtonFR from 'components/AddToBasketButton/locales/AddToBasketButton_fr_CA';

function getPendingSkus(pendingBasketSkus) {
    return pendingBasketSkus.filter(item => {
        if (item.methodId) {
            item.method();

            return false;
        }

        return true;
    });
}

class AddToBasketButton extends BaseClass {
    state = {
        disabled: true,
        showAddToBasketModal: false,
        isSample: skuUtils.isSample(this.props.sku),
        isAdded: false,
        isLoading: false,
        basketIsBopisKohlsAndHasItems: false,
        clickIsFromBazaar: false,
        isEligible: false,
        basketType: null,
        // In-flight guard against double-tap while the cart round trip is pending.
        isAddingReward: false
    };

    executeAddToBasketLogic = () => {
        if (!Location.isBasketPage() && !Location.isCheckout()) {
            this.props.setBasketType(null);
        }

        const {
            sku, isRRCModal, isRewardItem, rewardFulfillmentConfiguration, showRewardFulfillmentMethodModal, isQuickLook, replaceProduct
        } =
            this.props;

        const isRougeRewardCard = skuUtils.isRougeRewardCard(sku);
        const isBiReward = skuUtils.isBiReward(sku);

        let handleClick = !isRRCModal && isRougeRewardCard ? this.addClickModal : this.handleAddClick;

        if (this.state.isInBasket && (this.state.isSample || isRougeRewardCard || isBiReward)) {
            handleClick = this.handleAddClick;
        }

        if (
            !this.state.isInBasket &&
            isRewardItem &&
            rewardFulfillmentConfiguration?.shouldShowRewardFulfillmentMethodModal &&
            Location.isBasketPage()
        ) {
            handleClick = () => showRewardFulfillmentMethodModal(true, { sku });
        }

        if (!isQuickLook && chooseOptionsModalUtils.shouldShowChooseOptionsModal(this.props)) {
            handleClick = () => this.handleShowChooseOptionsModal(this.props);
        }

        // Main Kill Switch used to hide/show the OOS Alternate Link feature
        const showOOSAlternateLink = Sephora.configurationSettings?.isSelectAlternateForSamples?.isEnabled || false;

        // Handles the product replacement use case.
        if (showOOSAlternateLink) {
            const { removeProductFromBasket, skuToReplace = Empty.object, productIdToReplace = Empty.String } = this.props;

            if (replaceProduct) {
                if (removeProductFromBasket) {
                    removeProductFromBasket({ sku: skuToReplace, productId: productIdToReplace })
                        .then(() => {
                            // Continues adding the select product after the removal is complete.
                            this.addClick();
                            this.setState({ isLoading: false });
                        })
                        .catch(error => {
                            Sephora.logger.error('Failed to remove product from basket:', error);
                            this.setState({ isLoading: false });
                        });

                    return;
                }
            }
        }

        if (handleClick === this.handleAddClick) {
            this.addClick();
        } else {
            handleClick();
        }

        // Clear loading state after logic completes
        this.setState({ isLoading: false });
    };

    handleClickButton = e => {
        e.stopPropagation();
        e.preventDefault();

        // Imperatively disable the button for instant visual feedback without
        // triggering React's synchronous reconciliation in the click task.
        // React takes over the disabled state once the deferred setState commits.
        const el = ReactDOM.findDOMNode(this);

        if (el) {
            el.disabled = true;
        }

        deferTaskExecution(() => {
            this.setState({ isLoading: true }, () => {
                if (isIOSSafari()) {
                    this.executeAddToBasketLogic();
                } else {
                    deferTaskExecution(this.executeAddToBasketLogic);
                }
            });
        });
    };

    isDisabled = ({ isAppExclusive, isInAutoReplenishmentBasket }) => {
        const {
            sku, product, disabled, isCustomSets, preferredStore, autoReplenishChecked, isRewardItem, isBIPointsAvailable
        } = this.props;
        const basketType = this.state.basketType || this.props.basketType;
        const { preferredStoreInfo } = preferredStore;
        const { customSetsChoices = Empty.Array } = product || Empty.Object;

        const isBOPISAndUnavailable =
            basketType === BasketType.BOPIS &&
            (skuUtils.isReservationNotOffered(sku) ||
                (!Sephora.configurationSettings.isBOPISEnabled && preferredStoreInfo?.isBopisable) ||
                (!Sephora.configurationSettings.isROPISEnabled && preferredStoreInfo?.isRopisable) ||
                (!preferredStoreInfo?.isBopisable && !preferredStoreInfo?.isRopisable));

        const isRewardAndDisabled = isRewardItem && isBIPointsAvailable && !this.state.isInBasket && this.state.isRewardDisabled;
        const isAddedSample = this.state.isInBasket && this.state.isSample;

        return (
            (!this.props.isExperiment &&
                (this.state.disabled ||
                    (disabled && !isAddedSample) ||
                    (skuUtils.isBiExclusive(sku) && !skuHelpers.isBiQualify(sku)) ||
                    skuUtils.isGwp(sku) ||
                    isAppExclusive ||
                    isBOPISAndUnavailable ||
                    (isCustomSets && customSetsChoices.length === 0))) ||
            isRewardAndDisabled ||
            (isRewardItem && this.state.isAddingReward) ||
            (autoReplenishChecked && isInAutoReplenishmentBasket && !isChangeQuantityEnabled())
        );
    };

    /**
     * Gets the AddToBasket button styles for the increaseATBButtonOnPdp A/B test.
     *
     * The base styles (in-stock / out-of-stock sizing) are owned by RegularProduct —
     * `increaseATBButtonOnPdpStyle` is computed there and passed down as a prop.
     * This method owns only the disabled-state override (`styles.increaseATBButtonOnPdp.isDisabled`).
     * When decommissioning this test, both files must be updated.
     *
     * @param {boolean} isButtonDisabled - True when the button is disabled (includes loading and BOPIS states)
     * @returns {Array|null} Emotion style array, or null when the test is off
     */
    getIncreaseATBButtonOnPdpStyles = isButtonDisabled => {
        const { increaseATBButtonOnPdpStyle } = this.props;

        if (increaseATBButtonOnPdpStyle) {
            return [increaseATBButtonOnPdpStyle, isButtonDisabled && styles.increaseATBButtonOnPdp.isDisabled];
        }

        return null;
    };

    render() {
        const getText = getLocalisedDataFromResource(AddToBasketButtonEN, AddToBasketButtonFR);
        const isUSDesktopPurchaseHistory = Location.isPurchaseHistoryPage() && LanguageLocale.isUS() && Sephora.isDesktop();

        /* eslint-disable prefer-const */
        let {
            sku,
            variant,
            text,
            disabled,
            isRRCModal,
            analyticsContext,
            originalContext,
            productId,
            isQuickLook,
            promoPanel,
            containerTitle,
            isBIRBReward,
            isBIRBPageRewardModal,
            productName,
            basketType,
            isAddFullSize,
            callback,
            isCustomSets,
            isAddButton,
            displayQuantityPickerInATB,
            preferredStore,
            autoReplenishChecked,
            rootContainerName,
            isMultiProductsAdd,
            isRewardItem,
            onlyUseTextProp,
            isBIPointsAvailable,
            isRwdBasketPage,
            onSuccess,
            customStyle,
            productSampleModal,
            isSharableList = false,
            ...props
        } = this.props;

        const { basketIsBopisKohlsAndHasItems, isInAutoReplenishmentBasket } = this.state;
        /* eslint-enable prefer-const */

        const isBiReward = skuUtils.isBiReward(sku);

        const { isChooseOptionsModal } = this.props;
        const isOutOfStock = skuHelpers.isSkuOutOfStockByBasketType(sku, basketType, isChooseOptionsModal);
        const isCustomSetsOutOfStock =
            isCustomSets && skuHelpers.isSkuOutOfStockByBasketType(this.props.product?.currentSku, basketType, isChooseOptionsModal);
        // isDisabled omitted intentionally — out-of-stock has its own style path in RegularProduct
        const atbStyles = this.getIncreaseATBButtonOnPdpStyles();
        const outOfStockCustomStyle = atbStyles ? [...(Array.isArray(customStyle) ? customStyle : [customStyle]), ...atbStyles] : customStyle;

        if (isSharableList && skuUtils.isCountryRestricted(sku)) {
            return (
                <Text
                    is='p'
                    color='gray'
                >
                    {getText('itemShip')}
                </Text>
            );
        } else if (isOutOfStock || isCustomSetsOutOfStock) {
            return (
                <React.Fragment>
                    <OutOfStockButton
                        {...props}
                        isRewardItem={isRewardItem}
                        basketType={basketType}
                        variant={variant}
                        analyticsContext={analyticsContext}
                        sku={isCustomSets ? this.props.product?.currentSku : sku}
                        customStyle={outOfStockCustomStyle}
                    />
                </React.Fragment>
            );
        } else {
            const { isAdded } = this.state;

            const isRougeRewardCard = skuUtils.isRougeRewardCard(sku);

            if (this.state.isInBasket && (this.state.isSample || isRougeRewardCard || isBiReward)) {
                text = getText('remove');
                disabled = false;
            }

            const isAppExclusive = skuUtils.isAppExclusive(sku);

            // prevent button width shift during `isAdded` state
            if (!props.minWidth && !text) {
                props.minWidth = isAddButton ? '5.63em' : '10.47em';
            }

            const isDisabled = this.isDisabled({
                isAppExclusive,
                isInAutoReplenishmentBasket
            });

            const isButtonDisabled = isDisabled || basketIsBopisKohlsAndHasItems || this.state.isLoading;

            let variantProp = variant || ADD_BUTTON_TYPE.SECONDARY;

            if (basketType === BasketType.BOPIS) {
                variantProp = ADD_BUTTON_TYPE.SPECIAL;
            }

            const isRewardCTATwoLines = isRewardItem && LanguageLocale.isFRCanada() && this.state.isInBasket && this.props.isOmniRewardEnabled;

            const isAddingReward = isRewardItem && this.state.isAddingReward;

            return (
                <Button
                    {...props}
                    variant={variantProp}
                    className={isAdded ? 'is-active' : null}
                    disabled={isButtonDisabled}
                    aria-disabled={isAddingReward || undefined}
                    aria-busy={isAddingReward || undefined}
                    onClick={this.handleClickButton}
                    css={[
                        customStyle,
                        // Productionalized: Restock button on Buy It Again page (US Desktop only)
                        isUSDesktopPurchaseHistory && styles.restockButton,
                        isRewardCTATwoLines && styles.expandRewardButton,
                        ...(this.getIncreaseATBButtonOnPdpStyles(isButtonDisabled) ?? [])
                    ]}
                    maxWidth={productSampleModal ? '80px' : null}
                >
                    {this.renderBasketText({
                        isAppExclusive,
                        isAdded,
                        removeText: text,
                        displayQuantityPickerInATB,
                        isUSDesktopPurchaseHistory
                    })}
                </Button>
            );
        }
    }

    // Get the secondary text (the text that appears under the main text, related to Auto Replenishment,
    // Same Day Delivery) for the Add to Basket button
    getSecondaryText = ({ sameDayTitle, supportedBasketType, isBiReward }) => {
        if (isBiReward) {
            return undefined;
        }

        const { autoReplenishChecked, sku } = this.props;

        if (autoReplenishChecked && sku.isReplenishmentEligible) {
            return 'autoReplenish';
        }

        // Handle Same-Day / Fast Delivery based on feature flag
        if (supportedBasketType === BasketType.SameDay) {
            if (isNDDNewDeliveryName()) {
                // Feature flag ON: Use "Fast Delivery" (ignore API sameDayTitle)
                return 'fastDelivery';
            }

            // Feature flag OFF: Use existing logic
            return sameDayTitle ? 'sameDayCustomDelivery' : 'sameDayDelivery';
        }

        if (supportedBasketType === BasketType.Standard) {
            return 'standardShipping';
        }

        return BASKET_TYPE_TO_TEXT[supportedBasketType];
    };

    renderTwoLines = ({ getText }) => {
        const { suppressCheckmark } = this.props;

        return (
            <Flex
                flexDirection='column'
                paddingLeft={suppressCheckmark ? 2 : 4}
                paddingRight={2}
            >
                <Flex
                    fontWeight='bold'
                    alignItems='center'
                >
                    {suppressCheckmark ? null : (
                        <Icon
                            name='checkmark'
                            size='1em'
                            css={{
                                position: 'absolute',
                                transform: `translateX(calc(-100% - ${space[1]}px))`
                            }}
                        />
                    )}
                    {getText('added')}
                </Flex>
                <Link
                    color='blue'
                    fontSize='11px'
                    fontWeight='normal'
                    children={getText('remove')}
                />
            </Flex>
        );
    };

    // Renders the text inside the Add to Basket button, including its component structure, based on the
    // button's state and the current context
    renderBasketText = ({ isAppExclusive, isAdded, removeText, isUSDesktopPurchaseHistory }) => {
        const { basketIsBopisKohlsAndHasItems, isInAutoReplenishmentBasket } = this.state;
        const {
            isRwdBasketPage,
            onlyUseTextProp,
            sku,
            isExperiment,
            autoReplenishChecked,
            isAddButton,
            isCustomSets,
            basketType,
            isAddTwoLines,
            isRewardItem,
            itemsByBasket,
            pickupBasketItems,
            isOmniRewardEnabled,
            isRougeExclusiveCarousel
        } = this.props;
        let fontWeightMainText = 'bold';
        let fontWeightSecondaryText = 'normal';
        const getText = getLocalisedDataFromResource(AddToBasketButtonEN, AddToBasketButtonFR);
        let { ctaTwoLines } = this.props;

        if (isRewardItem || isRougeExclusiveCarousel) {
            ctaTwoLines = true;
        }

        if ((isRwdBasketPage && removeText === getText('remove')) || (isAddTwoLines && removeText === getText('remove'))) {
            return this.renderTwoLines({ getText });
        }

        let forceUseSecondaryText = false;
        let secondaryText;

        if ((isRewardItem || isRougeExclusiveCarousel) && isOmniRewardEnabled && this.state.isInBasket) {
            const basketForReward = findBasketTypeBySkuId(sku.skuId, itemsByBasket, pickupBasketItems);

            if (basketForReward) {
                forceUseSecondaryText = true;

                // Apply Fast Delivery branding when kill switch is enabled (GUAR-7658)
                let basketTypeKey = basketForReward;

                if (basketForReward === 'SameDay' && isNDDNewDeliveryName()) {
                    basketTypeKey = 'FastDelivery';
                }

                secondaryText = getText(basketTypeKey);
            }
        }

        if (onlyUseTextProp != null && !forceUseSecondaryText) {
            return removeText || onlyUseTextProp;
        }

        const isBiExclusive = skuUtils.isBiExclusive(sku);

        if (!isExperiment && (isAppExclusive || (isBiExclusive && !skuHelpers.isBiQualify(sku)))) {
            return (
                <span
                    css={this.props.size === 'sm' && { fontSize: '.875em' }}
                    children={`${skuUtils.getExclusiveText(sku)} ${getText('exclusive')}`}
                />
            );
        }

        const addPrefix = isAdded ? 'added' : 'add';
        let mainText = getText(isAddButton ? addPrefix : `${addPrefix}ToBasket`);

        if (removeText) {
            mainText = removeText;
        }

        if (isCustomSets) {
            mainText = getText('addAllToBasket');
        }

        if (basketIsBopisKohlsAndHasItems) {
            mainText = getText('alreadyAddedKohls');
            fontWeightMainText = 'normal';
            fontWeightSecondaryText = 'bold';
        }

        if (autoReplenishChecked && isInAutoReplenishmentBasket && !isChangeQuantityEnabled()) {
            mainText = getText('alreadyAddedKohls');
            fontWeightMainText = 'bold';
            fontWeightSecondaryText = 'normal';
        }

        // Productionalized: "Restock" text on Buy It Again page (US Desktop only) - TS-5047
        if (isUSDesktopPurchaseHistory) {
            mainText = getText('restock');
        }

        const isBiReward = skuUtils.isBiReward(sku);
        const sameDayTitle = this.props.product?.currentSku?.sameDayTitle;
        const supportedBasketType = isCustomSets || isBiReward ? BasketType.Standard : basketType;

        if (!forceUseSecondaryText) {
            secondaryText = this.getSecondaryText({
                sameDayTitle,
                supportedBasketType,
                isBiReward
            });
        }

        const getLocaleLiteralString = () => {
            if (forceUseSecondaryText) {
                return secondaryText;
            }

            const dynamicText = autoReplenishChecked
                ? [`${this.props.replenishmentFreqNum} ${formatFrequencyType(this.props.replenishmentFreqNum, this.props.replenishmentFreqType)}`]
                : sameDayTitle
                    ? [sameDayTitle]
                    : '';

            return getText(secondaryText, dynamicText);
        };

        return secondaryText && ctaTwoLines ? (
            <Text
                fontSize='sm'
                fontWeight={fontWeightMainText}
            >
                {mainText}
                <Text
                    display='block'
                    fontWeight={fontWeightSecondaryText}
                    fontSize={`${fontSizes.xs}px`}
                    marginTop='.125em'
                >
                    {getLocaleLiteralString()}
                </Text>
            </Text>
        ) : (
            mainText
        );
    };

    setPropertiesFromBasket = () => {
        const {
            basketItems, pickupBasketItems, itemCount, fromBazaar, sku, isReplacementOrder
        } = this.props;

        if (isReplacementOrder) {
            this.setState({
                isInBasket: false,
                disabled: itemCount === null,
                isInAutoReplenishmentBasket: false,
                clickIsFromBazaar: fromBazaar
            });

            return;
        }

        const basketType = this.state.basketType || this.props.basketType;
        const currentBasketItems = basketType === BasketType.BOPIS ? pickupBasketItems : basketItems;

        if (currentBasketItems) {
            this.setState({
                isInBasket: skuHelpers.isInBasket(sku?.skuId, basketType?.length ? { items: currentBasketItems } : null),
                disabled: itemCount === null,
                isInAutoReplenishmentBasket: skuHelpers.isInAutoReplenishmentBasket(sku?.skuId, { items: basketItems }),
                clickIsFromBazaar: fromBazaar
            });
        }
    };

    componentDidMount() {
        const { isNthCategoryPage, sku } = this.props;

        const basketTypeFromStorage = Storage.local.getItem(LOCAL_STORAGE.BASKET_TYPE);
        this.setState({ basketType: this.props.basketType || basketTypeFromStorage });

        skuUtils.isRewardDisabled(sku).then(isRewardDisabled => {
            this.setState({
                isRewardDisabled,
                isEligible: sku.isEligible
            });
        });

        this.setBasketIsBopisKohlsAndHasItems();

        if (isNthCategoryPage) {
            this.setState({ disabled: false });
        } else {
            this.setPropertiesFromBasket();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { sku, basketItems, user, isRewardItem } = this.props;
        const isBirthdayGift = skuUtil.isBirthdayGift(sku);

        if (this.props.basketType !== prevProps.basketType) {
            const basketTypeFromStorage = Storage.local.getItem(LOCAL_STORAGE.BASKET_TYPE);
            this.setState({ basketType: this.props.basketType || basketTypeFromStorage });
        }

        if (
            sku.isEligible !== prevProps.sku.isEligible ||
            (isRewardItem && sku.isEligible !== prevState.isEligible) ||
            isBirthdayGift ||
            JSON.stringify(prevProps.user.beautyInsiderAccount) !== JSON.stringify(user.beautyInsiderAccount)
        ) {
            skuUtils.isRewardDisabled(this.props.sku).then(isRewardDisabled => {
                // Prevent an infinite loop when opening the Rewards modal
                if (this.state.isRewardDisabled !== isRewardDisabled) {
                    this.setState({
                        isRewardDisabled,
                        isEligible: this.props.sku.isEligible
                    });
                }
            });
        }

        if ((basketItems && basketItems !== prevProps.basketItems) || sku?.skuId !== prevProps.sku?.skuId) {
            this.setPropertiesFromBasket();
        }

        if (this.checkforBopisAtKohls(prevProps)) {
            this.setBasketIsBopisKohlsAndHasItems(prevProps);
        }
    }

    checkforBopisAtKohls = prevProps => {
        const currentStoreInfo = this.props.preferredStore?.preferredStoreInfo;
        const prevStoreInfo = prevProps.preferredStore?.preferredStoreInfo;
        const currentSku = this.props.sku;
        const prevSku = prevProps.sku;
        const diffBasket = this.props.basketItems && this.props.basketItems !== prevProps.basketItems;
        const diffPrefStoreType = currentStoreInfo?.storeType !== prevStoreInfo?.storeType;
        const diffPrefStoreId = currentStoreInfo?.storeId !== prevStoreInfo?.storeId;
        const diffBasketType = this.props.basketType !== prevProps.basketType;
        const diffSkuId = currentSku?.skuId !== prevSku?.skuId;

        return diffBasket || diffPrefStoreType || diffPrefStoreId || diffBasketType || diffSkuId;
    };

    setBasketIsBopisKohlsAndHasItems = () => {
        const { sku, pickupBasketItems, preferredStore } = this.props;
        const basketType = this.state.basketType || this.props.basketType;

        const hasKohlsItemsInBopisBasket = pickupBasketItems?.filter(item => item.sku.skuId === sku.skuId).length > 0;
        const isBopisBasket = basketType === BasketType.BOPIS;
        const isKohlsStore = storeUtils.isKohlsStore(preferredStore?.preferredStoreInfo);
        const basketIsBopisKohlsAndHasItems = hasKohlsItemsInBopisBasket && isBopisBasket && isKohlsStore;

        this.setState({ basketIsBopisKohlsAndHasItems });
    };

    getAddToBasketSuccessCallback = (callback = Empty.Function) => {
        const { onSuccess, updateAttributionData } = this.props;

        return response => {
            // Defer analytics to improve INP by not blocking main thread
            deferTaskExecution(() => {
                processEvent.process(anaConsts.ADD_TO_CART);
            });

            if (isFunction(onSuccess)) {
                onSuccess();
            }

            // CSF Affiliate u1 update attribution data.
            // CSF-1793: `updateAttributionData` is only passed from CSF
            // contexts (CSFProductGrid / HorizontalProductTile / PostDetails).
            // When DC KS is on, DC owns CSF attribution end-to-end, so the
            // legacy callback must not fire from the ATB success path. The
            // DC ATB U1 refresh (below) is unaffected by this gate.
            if (!isDynamicCommissioningEnabled() && isFunction(updateAttributionData)) {
                updateAttributionData();
            }

            if (isDynamicCommissioningEnabled()) {
                // Update the DC active/current U1 to reflect the
                // product-interaction context per the U1 Parameter
                // Analytics Training Guide Rule 3 BEFORE logging the
                // ATB event. This guarantees the ATB event (and any
                // subsequent in-journey events / Rakuten ping) carry
                // the post-interaction U1. Covers both inline ATB and
                // quicklook ATB — `isQuickLook` only switches the
                // event type, not the interaction semantics.
                //
                // CSF-1791: `applyProductInteractionToActiveCommissioningU1`
                // is async — it fetches a fresh `siteId` for the new u1 and
                // persists `{ u1, siteId }` together. The ATB event must run
                // ONLY AFTER a successful update; if the helper returns
                // `null` (siteId fetch failed / no active state / missing
                // motomProductId), active state keeps the PRIOR pair, and
                // firing ATB anyway would log the new productId against a
                // stale {u1, siteId} — exactly the "skip gracefully rather
                // than log a new U1 with a stale/mismatched siteId" case
                // forbidden by the AC. The missing-fields gate inside
                // `logCsfAtbEvent` does not catch this (prior pair has all
                // fields populated), so we gate at the call site.
                const logAfterUpdate = () => this.logCsfAtbEvent().catch(Empty.Function);

                if (Location.isCreatorStoreFrontPage()) {
                    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
                    const { section = '', identifier = null } = getCsfRoute(pathname);
                    const motomProductId = this.props.product?.motomProductId;
                    const { dynamicCommissioningAtbSource } = this.props;

                    const isBestsellersCarousel = dynamicCommissioningAtbSource === CSF_DC_ATB_SOURCES.BESTSELLERS_CAROUSEL;
                    const hasMotomProductId = motomProductId !== null && motomProductId !== undefined && motomProductId !== '';

                    // CSF-1851: explicit parent-owned eligibility gate.
                    // DC ATB fires only when the parent surface declares itself
                    // DC-eligible by passing `dynamicCommissioningAtbSource`
                    // (one of `CSF_DC_ATB_SOURCES`). Surfaces that don't pass
                    // it are descoped by design.
                    //
                    // Product-identifier requirement is source-dependent:
                    //   - PRODUCT_GRID / POST_DETAILS: require `motomProductId`
                    //     to build a product-specific u1/siteId pair.
                    //   - BESTSELLERS_CAROUSEL (CSF-1891): Constructor.io /
                    //     RecService feed doesn't provide `motomProductId`;
                    //     the U1 uses the literal `"bestseller"` sentinel via
                    //     `identifierOverride`, so no motom check is needed.
                    if (dynamicCommissioningAtbSource && (hasMotomProductId || isBestsellersCarousel)) {
                        // Fire-and-forget: must not block the rest of the
                        // success callback (basket modal, error handling, etc.).
                        (async () => {
                            try {
                                const updatedCommissioningU1State = await applyProductInteractionToActiveCommissioningU1({
                                    section,
                                    identifier,
                                    motomProductId,
                                    identifierOverride: isBestsellersCarousel ? CSF_DC_U1_BESTSELLER_SENTINEL : null
                                });

                                // Gate ATB only on cases the U1 update was
                                // ATTEMPTED but could not produce a fresh
                                // `{ u1, siteId }` pair (no active state, or
                                // siteId fetch failed for the new u1). In
                                // those cases logging ATB would attribute
                                // the new product against a stale pair —
                                // exactly the case the AC forbids.
                                if (updatedCommissioningU1State) {
                                    await logAfterUpdate();
                                }
                            } catch (e) {
                                // Swallow — DC analytics must never break ATB UX.
                            }
                        })();
                    }
                } else {
                    logAfterUpdate();
                }
            }

            callback();

            let errorMessage = '';

            if (response && response.basketLevelMessages) {
                errorMessage = response.basketLevelMessages.find(msg => msg.messageContext === PROMO_WARNING)?.messages[0] || '';
            }

            if (errorMessage.length) {
                promoUtils.showWarningMessage(errorMessage);
            } else if (response && !response.errors && !Location.isBasketPage() && !this.props.suppressAddToCartModal) {
                // Added a property to specifically suppress showing the Add to Cart modal
                if (window.matchMedia(breakpoints.smMin).matches) {
                    this.showAddToBasketModal();
                }
            }
        };
    };

    logCsfAtbEvent = async () => {
        if (!Location.isCreatorStoreFrontPage() || !isDynamicCommissioningEnabled()) {
            return;
        }

        // Read u1/siteId from the persisted DC active state and creator_id from the
        // creator profile — `applyProductInteractionToActiveCommissioningU1` ran in the
        // success callback just before this, so the active state already
        // reflects the post-product-interaction U1 (per the U1 Parameter
        // Analytics Training Guide Rule 3).
        const expectedSubAffiliateId = this.props.creatorProfileData?.creatorProfile?.attributionDetails?.subAffiliateId ?? null;
        const active = getActiveCommissioningU1State({ expectedSubAffiliateId });
        const creatorId = this.props.creatorProfileData?.creatorProfile?.creatorId ?? null;
        const u1 = active?.u1 ?? null;
        const siteId = active?.siteId ?? null;
        const productId = this.props.sku?.productId || this.props.product?.productDetails?.productId || this.props.product?.productId || null;
        const motomProductId = this.props.product?.motomProductId || null;
        const eventType = this.props.isQuickLook ? CSF_EVENT_TYPES.QUICKLOOK_ATB : CSF_EVENT_TYPES.ADD_TO_CART;

        await logCsfAtbEvent({
            eventType,
            creatorId,
            u1,
            u5: getCsfDynamicCommissioningU5({ expectedSubAffiliateId }),
            siteId,
            productId,
            motomProductId
        });
    };

    getAnalyticsData = () => {
        const {
            sku,
            productId,
            productName,
            product = Empty.Object,
            platform,
            containerTitle,
            carouselName,
            isBIRBReward,
            origin,
            pageName,
            originalContext,
            isBIRBPageRewardModal = false,
            isAddFullSize = false,
            rootContainerName,
            skuQuantity,
            displayQuantityPickerInATB,
            isMultiProductsAdd,
            autoReplenishChecked,
            analyticsContext,
            personalizedInternalCampaign,
            basket
        } = this.props;

        const basketType = this.state.basketType || this.props.basketType;

        const category = product?.parentCategory?.displayName || sku?.parentCategory?.displayName;
        const brandName = product?.productDetails?.brand?.displayName || sku.brandName;
        const productDescription = product?.productDetails?.shortDescription
            ? product.productDetails.shortDescription.replace(/<\/?\w+[^>]*\/?>/g, '')
            : undefined;
        const isCreatorStoreFrontPage = Location.isCreatorStoreFrontPage();
        const motomProductId = isCreatorStoreFrontPage ? product?.motomProductId : null;

        let productStrings = '';

        if (autoReplenishChecked) {
            productStrings = [
                anaUtils.buildAutoReplenishDeliveryFrequencyPoductString({
                    skuId: sku.skuId,
                    qty: skuQuantity,
                    price: formatSiteCatalystPrice(sku.listPrice),
                    frequency: sku.replenishmentFreqNum,
                    frequencyType: sku.replenishmentFreqType?.toLowerCase()
                })
            ];
        } else {
            productStrings = [
                anaUtils.buildSingleProductString({
                    sku: this.props.sku,
                    isQuickLook: false,
                    newProductQty: skuQuantity,
                    displayQuantityPickerInATB,
                    basket,
                    isSameDayBasket: basketType === BasketType.SameDay
                })
            ];
        }

        return {
            ...(motomProductId && { motomProductId }),
            productId: sku.productId || product?.productDetails?.productId || productId,
            productName: sku.productName || productName || product?.productDetails?.displayName,
            productStrings,
            displayQuantityPickerInATB,
            productDescription,
            brandName,
            category,
            skuType: sku.type,
            origin,
            pageName,
            originalContext,
            platform,
            isBIRBReward,
            containerTitle,
            carouselName,
            isBIRBPageRewardModal,
            isAddFullSize,
            rootContainerName,
            isPickup: basketType === BasketType.BOPIS,
            isSameDay: basketType === BasketType.SameDay,
            isMultiProductsAdd,
            sku,
            isSameDayDeliveryEligible: sku.isSameDayEligibleSku,
            isOnlineOnly: sku.isOnlineOnly,
            isAvailablePreferredStore: basketType === BasketType.BOPIS ? 'Yes' : 'No',
            analyticsContext,
            personalizedInternalCampaign,
            basket
        };
    };

    triggerAddToBasketAction = () => {
        const {
            sku,
            quantity = 1,
            analyticsContext,
            samplePanel,
            basketType,
            showBasketQuickAdd = false,
            product,
            showBasketCarouselErrorModal = false,
            itemsByBasket,
            pickupBasketItems,
            isChooseOptionsModal,
            pageName,
            isRewardItem
        } = this.props;

        if (isRewardItem && this.state.isAddingReward) {
            return;
        }

        if (isRewardItem && isRewardBundlingEnabled()) {
            // Direct assignment (not setState): the guard above must read it synchronously
            // on an immediate repeat tap, and unmounted test instances warn on setState.
            // Re-render is triggered by the dispatch(refreshBasket|updateBasket) that follows
            // the cart round-trip — do not remove those without addressing this flag's paint.
            this.state.isAddingReward = true;
        }

        const productId = sku.productId || product?.productDetails?.productId || this.props.productId;

        let rewardBasketType;
        const isBiReward = skuUtils.isBiReward(sku);

        const autoReplenishFrequency = this.props.autoReplenishChecked
            ? `${this.props.replenishmentFreqType}:${this.props.replenishmentFreqNum}`
            : '';

        if (isBiReward && this.state.isInBasket) {
            rewardBasketType = findBasketTypeBySkuId(sku.skuId, itemsByBasket, pickupBasketItems);
        }

        const addToBasketResult = this.props.addToBasket(
            sku,
            rewardBasketType || basketType,
            quantity,
            this.getAddToBasketSuccessCallback(),
            analyticsContext,
            samplePanel,
            this.getAnalyticsData(),
            showBasketQuickAdd,
            this.props.autoReplenishChecked,
            autoReplenishFrequency,
            productId,
            this.props.isCommunityGallery,
            showBasketCarouselErrorModal,
            isChooseOptionsModal,
            product,
            pageName
        );

        if (isRewardItem) {
            const clearAddingRewardFlag = () => {
                this.state.isAddingReward = false;
            };

            Promise.resolve(addToBasketResult).then(clearAddingRewardFlag, clearAddingRewardFlag);
        }
    };

    showAddToBasketModal = () => {
        const {
            product,
            sku,
            quantity = 1,
            analyticsContext,
            basketType,
            autoReplenishChecked,
            replenishmentFreqNum,
            replenishmentFreqType,
            isAutoReplenMostCommon,
            pickupBasketItems,
            basketItems,
            pageName,
            fromChooseOptionsModal
        } = this.props;
        const currentBasketItems = basketType === BasketType.BOPIS ? pickupBasketItems : basketItems;
        const isRewardRemoval =
            skuUtils.isBiReward(sku) && skuHelpers.isInBasket(sku.skuId, basketType?.length ? { items: currentBasketItems } : null);
        const preferredStoreName =
            basketType === BasketType.BOPIS ? storeUtils.getStoreDisplayName(this.props.preferredStore?.preferredStoreInfo) : undefined;

        if (this.props?.triggerAnalytics) {
            this.props.triggerAnalytics();
        }

        if (!isRewardRemoval) {
            this.props.showAddToBasketModal({
                analyticsContext,
                basketType,
                isOpen: true,
                preferredStoreName,
                product: product || sku.primaryProduct,
                quantity,
                sku,
                replenishmentFrequency: autoReplenishChecked ? `${replenishmentFreqType}:${replenishmentFreqNum}` : '',
                replenishmentSelected: autoReplenishChecked,
                isAutoReplenMostCommon,
                pageName,
                fromChooseOptionsModal
            });
        }
    };

    addClickModal = () => {
        const currentSkuType = skuUtils.getProductType(this.props.sku);
        let areTermsAndConditionsAccepted = false;

        if (this.props?.triggerAnalytics) {
            this.props.triggerAnalytics();
        }

        // If the user has clicked “Add to Basket” to add a Rouge Reward Card,
        // make sure she has accepted T&C
        if (currentSkuType === skuUtils.skuTypes.ROUGE_REWARD_CARD) {
            areTermsAndConditionsAccepted = rrcUtils.areRRCTermsConditionsAccepted();
        }

        if (!areTermsAndConditionsAccepted) {
            this.props.showRougeRewardCardModal({
                isOpen: !areTermsAndConditionsAccepted,
                sku: this.props.sku,
                isRougeExclusiveCarousel: this.props.isRougeExclusiveCarousel || false,
                analyticsContext: this.props.analyticsContext
            });
        } else {
            this.triggerAddToBasketAction();
        }

        this.blurEl();
    };

    addClick = () => {
        if (this.props?.triggerAnalytics) {
            this.props.triggerAnalytics();
        }

        const basketType = this.state.basketType || this.props.basketType;

        if (this.props.isNthCategoryPage) {
            quicklookModalUtils.dispatchQuicklook({
                productId: this.props.sku.productId,
                skuType: this.props.sku.type,
                options: { addCurrentSkuToProductChildSkus: true },
                sku: this.props.sku,
                rootContainerName: this.props.rootContainerName,
                productStringContainerName: this.props.productStringContainerName,
                origin: this.props.origin,
                analyticsContext: this.props.analyticsContext
            });
        } else if (this.props.sku && Array.isArray(this.props.sku) && this.props.sku.length > 0) {
            const products = this.props.sku.map(item => ({
                ...item,
                qty: item.qty || 1
            }));
            const qty = products
                .map(item => item.qty)
                .reduce((prev, curr) => {
                    return prev + curr;
                });
            this.props.addMultipleSkusToBasket(
                products,
                qty,
                this.getAddToBasketSuccessCallback(() => this.props.clearPendingProductList()),
                this.props.analyticsContext,
                this.getAnalyticsData(),
                undefined,
                true,
                basketType
            );

            productPageSOTBindings.addAllToBasket({ skus: this.props.sku });
        } else if (this.props.isReplacementOrder) {
            this.props.addRemoveSample(this.props.sku);
        } else {
            const {
                isCustomSets,
                pendingBasketSkus: pendingBasketSkusData,
                promoPanel,
                sku,
                quantity,
                analyticsContext,
                addMultipleSkusToBasket,
                closeParentModal,
                updateMsgPromo,
                clearPendingProductList
            } = this.props;

            this.setState({ isAdded: true }, () => setTimeout(() => this.setState({ isAdded: false }), ADDED_TEXT_TIMEOUT));

            if (!isCustomSets) {
                if (promoPanel === 'promo') {
                    updateMsgPromo(sku);
                } else {
                    let pendingBasketSkus = getPendingSkus(pendingBasketSkusData);

                    if (pendingBasketSkus.length > 0) {
                        const prod = {
                            skuId: sku.skuId,
                            qty: quantity || 1
                        };

                        pendingBasketSkus = [].concat([prod], pendingBasketSkusData);

                        const qty = pendingBasketSkus
                            .map(item => item.qty)
                            .reduce((prev, curr) => {
                                return prev + curr;
                            });

                        addMultipleSkusToBasket(
                            pendingBasketSkus,
                            qty,
                            this.getAddToBasketSuccessCallback(clearPendingProductList),
                            analyticsContext,
                            undefined,
                            undefined,
                            undefined,
                            basketType
                        );
                    } else {
                        if (closeParentModal) {
                            closeParentModal();
                        }

                        this.triggerAddToBasketAction();
                    }
                }
            }
        }

        this.blurEl();

        if (this.props.callback) {
            this.props.callback();
        }
    };

    blurEl = () => {
        const element = ReactDOM.findDOMNode(this);
        // Remove outlined focus state from the button
        element.blur();
    };

    /**
     * This workaround prevents occasional double-click events
     */
    handleAddClick = Debounce.preventDoubleClick(this.addClick, THROTTLE_DELAY);

    /**
     * Debounced version of showChooseOptionsModal to prevent duplicate API calls
     */
    handleShowChooseOptionsModal = Debounce.preventDoubleClick(data => {
        this.props.showChooseOptionsModal(data);
    });
}

const styles = {
    expandRewardButton: {
        [mediaQueries.smMax]: {
            maxHeight: 'none'
        }
    },
    increaseATBButtonOnPdp: {
        isDisabled: {
            [mediaQueries.lg]: {
                padding: `${space[3]}px ${space[5]}px`
            }
        }
    },
    restockButton: {
        backgroundColor: colors.transparent
    }
};

export default wrapComponent(AddToBasketButton, 'AddToBasketButton', true);
